import { useContext, useState } from 'react'
import Box from '@mui/material/Box'
import Modal from '@mui/material/Modal'
import styles from './styles.module.css'
import PrimaryButton from '../../../../../global/components/buttons/primary-button/PrimaryButton'
import CircularProgress from '@mui/material/CircularProgress'
import { ToastNotificationContext } from '../../../../../global/context/toast-context/ToastNotificationContext'
import { fetchData } from '../../../../../global/utils/fetch'
import { putUkgPunchCardData } from '../api'

interface IUploadUkgModalProps {
  isOpen: boolean
  handleClosed: () => void
}

function UploadUkgDataModal(props: IUploadUkgModalProps) {
  const { isOpen, handleClosed } = props
  const [isFileUploading, setIsFileUploading] = useState(false)
  const { toastStatus, setToastStatus } = useContext(ToastNotificationContext)
  const title = 'Upload UKG Data'
  const description =
    'Please export "Report: All Punches Detailed: All Punches" report as a CSV from UKG and upload here.'

  async function handleUploadFileInput(e: any) {
    setIsFileUploading(true)
    try {
      const formData = new FormData()
      const file = e.target.files[0]
      formData.append('file', file)
      await fetchData(putUkgPunchCardData(formData))

      setToastStatus({
        ...toastStatus,
        isOpen: true,
        message: 'File uploaded successfully!',
        severity: 'success',
      })
    } catch (error: any) {
      console.error(error)

      setToastStatus({
        ...toastStatus,
        isOpen: true,
        message: error.message ?? '',
        severity: 'error',
      })
    } finally {
      e.target.value = null
      setIsFileUploading(false)
    }
  }

  return (
    <div>
      <Modal
        open={isOpen}
        onClose={handleClosed}
      >
        <Box className={styles.uploadModalContainer}>
          <div className={styles.title}>{title}</div>
          <div className={styles.contentContainer}>
            <div>{description}</div>
            <input
              style={{ display: 'none' }}
              id='fileUpload'
              onChange={handleUploadFileInput}
              type='file'
              accept='.csv'
            />
            <label
              htmlFor='fileUpload'
              style={{ whiteSpace: 'nowrap' }}
              className={styles.uploadButton}
            >
              Upload File
            </label>
          </div>
          {isFileUploading && <CircularProgress size={20} />}
          <PrimaryButton
            onClick={handleClosed}
            buttonName={'Close'}
          />
        </Box>
      </Modal>
    </div>
  )
}

export default UploadUkgDataModal
